import {Box, Grid, Theme} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import React, {FC, useCallback, useEffect, useRef} from 'react';
import {useSelector} from 'react-redux';
import {localized} from '../../../../i18n/i18n';
import {getCultureUrlParameters} from '../../../../state/features/urlSettings/url-settings-slice';
import {AppState} from '../../../../state/store';
import {validCountryIds} from '../../../../utilities/helpers/culture-settings-helper';
import {getConfigurationParamByName} from '../../../../utilities/helpers/product-helper';
import {BinaryButtonInput} from '../../../components/custom-components/configuration/dynamic-components/binary-button-input';
import {RecommondetionTextRow} from '../../../components/custom-components/configuration/dynamic-components/recommondetion-text-row';
import {hasBackRail, hasFrontRail, hasLeftRail, hasRightRail} from '../configuration-constants';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    grid: {
      width: '506px',
    },
    gridItem: {
      height: '120px',
    },
  }),
);

export interface PropsFromParent {}

export const Product3Step3: FC<PropsFromParent> = React.memo(({...props}) => {
  const classes = useStyles();
  const selectedProduct = useSelector((store: AppState) => store.projectReducer.selectedProduct);
  const urlParam = useSelector(getCultureUrlParameters);
  const myRef = useRef<null | HTMLDivElement>(null);

  const getSafetyRailDefault = useCallback(
    (railType: string) => {
      return (
        getConfigurationParamByName(selectedProduct, railType) ??
        (urlParam.contryId === validCountryIds.us ? 'true' : undefined)
      );
    },
    [selectedProduct, urlParam.contryId],
  );

  useEffect(() => {
    if (myRef && myRef.current) {
      myRef.current.scrollIntoView({block: 'end'});
    }
  }, []);

  return (
    <>
      <Box display="flex" justifyContent="center" alignItems="center" sx={{flexGrow: 1}}>
        <Grid container spacing={2.5} className={classes.grid}>
          <Grid ref={myRef} container spacing={3} className={classes.gridItem}>
            <RecommondetionTextRow recommondetionString={localized('PressalitSecurityShinesSuggestion')} />
          </Grid>
          <Grid container spacing={3} className={classes.gridItem}>
            <BinaryButtonInput
              formName={hasFrontRail}
              value1={'true'}
              value2={'false'}
              btnLabel1={localized('Yes')}
              btnLabel2={localized('No')}
              label={localized('HasFrontShine')}
              tooltipLabel={localized('ToolTipProduct1Step3_1')}
              defaultValue={getSafetyRailDefault(hasFrontRail)}
            />
          </Grid>

          <Grid container spacing={3} className={classes.gridItem}>
            <BinaryButtonInput
              formName={hasBackRail}
              value1={'true'}
              value2={'false'}
              btnLabel1={localized('Yes')}
              btnLabel2={localized('No')}
              label={localized('HasBackShine')}
              tooltipLabel={localized('ToolTipProduct1Step3_1')}
              defaultValue={getSafetyRailDefault(hasBackRail)}
            />
          </Grid>

          <Grid container spacing={3} className={classes.gridItem}>
            <BinaryButtonInput
              formName={hasLeftRail}
              value1={'true'}
              value2={'false'}
              btnLabel1={localized('Yes')}
              btnLabel2={localized('No')}
              label={localized('HasLeftShine')}
              tooltipLabel={localized('ToolTipProduct1Step3_2')}
              defaultValue={getSafetyRailDefault(hasLeftRail)}
            />
          </Grid>

          <Grid container spacing={3} className={classes.gridItem}>
            <BinaryButtonInput
              formName={hasRightRail}
              value1={'true'}
              value2={'false'}
              btnLabel1={localized('Yes')}
              btnLabel2={localized('No')}
              label={localized('HasRightShine')}
              tooltipLabel={localized('ToolTipProduct1Step3_3')}
              defaultValue={getSafetyRailDefault(hasRightRail)}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
});
